
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Caen dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Caen certifiée Google Partner, accompagne les entreprises caennaises pour booster leur visibilité en ligne et attirer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Caen dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Caen certifiée Google Partner, accompagne les entreprises caennaises pour booster leur visibilité en ligne et attirer plus de prospects.",
        },
      ],
    };
  },
};
